import useAppStore from '../store/appStore';

/**
 * Hook that returns the current user's email signature from Zustand store.
 * The signature is populated by AuthContext on login (from userProfile).
 * Returns the HTML signature string (or empty string if none configured).
 */
export const useEmailSignature = () => {
  const signature = useAppStore((s) => s.settingsEmailSignature);
  return signature || '';
};
